import domtoimage from "dom-to-image-more";
import ReactDOM from "react-dom";
import React from "react";

import BronzeAwardSVG from "./components/bronzeMedal";
import SilverAwardSVG from "./components/silverMedal";
import GoldAwardSVG from "./components/goldMedal";
import PlatinumAwardSVG from "./components/platinumMedal";
import DiamondAwardSVG from "./components/diamondAward";

const badgeComponents = {
  Bronze: BronzeAwardSVG,
  Silver: SilverAwardSVG,
  Gold: GoldAwardSVG,
  Platinum: PlatinumAwardSVG,
  Diamond: DiamondAwardSVG,
};

const downloadBadge = async (badgeName, userName, details) => {
  const { pointRange, organisationName, date } = details;
  const BadgeSVG = badgeComponents[badgeName];
  const curvedText = `POINT RANGE ${pointRange} · ${organisationName} · ${date}`;

  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.left = "-9999px";
  container.style.width = "400px";
  container.style.padding = "20px";
  container.style.textAlign = "center";
  container.style.background = "#fff";

  document.body.appendChild(container);

  ReactDOM.render(
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <BadgeSVG
        width={200}
        height={200}
        curvedText={curvedText} 
        curvedTextColor="#000"
        curvedTextFontSize={16}
        curvedTextFontWeight={700}
        curvedTextFontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
        curvedTextOffset="25%"
      />
      <div style={{ marginTop: "8px", fontWeight: "bold", fontSize: "16px" }}>{userName}</div>
    </div>,
    container
  );

  setTimeout(async () => {
    const scale = 3;
    const style = {
      transform: `scale(${scale})`,
      transformOrigin: "top left",
      width: container.offsetWidth + "px",
      height: container.offsetHeight + "px",
    };
  
    const dataUrl = await domtoimage.toPng(container, {
      width: container.offsetWidth * scale,
      height: container.offsetHeight * scale,
      style,
      filter: (node) => {
        // Exclude nodes related to external icon fonts (optional)
        if (node.tagName === "LINK" && node.href && 
            (node.href.includes("font-awesome") || node.href.includes("bootstrap-icons"))) {
          return false;
        }
        return true;
      },
    });
  
    const link = document.createElement("a");
    link.download = `${badgeName}_${userName}.png`;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    console.log("Badge downloaded successfully:", badgeName, userName);
  }, 300);
};

export { downloadBadge, badgeComponents };
